import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock } from 'lucide-react';
import { useLanguage } from '../../i18n';

/**
 * 博客文章卡片组件
 */
function BlogCard({ post }) {
  const { language } = useLanguage();

  const title = post.title[language];
  const description = post.description[language];
  const category = post.category[language];

  return (
    <Link
      to={`/blog/${post.slug}`}
      className="block group"
    >
      <article className="bg-white dark:bg-gray-800 rounded-2xl p-6 transition-all duration-300 hover:shadow-xl border border-gray-200 dark:border-gray-700 hover:border-indigo-300 dark:hover:border-indigo-600">
        {/* 分类标签 */}
        <div className="flex items-center gap-2 mb-3">
          <span className="px-3 py-1 text-xs font-medium bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 rounded-full">
            {category}
          </span>
        </div>

        {/* 标题 */}
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3 group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors line-clamp-2">
          {title}
        </h2>

        {/* 摘要 */}
        <p className="text-gray-600 dark:text-gray-400 mb-4 line-clamp-3">
          {description}
        </p>

        {/* 元信息 */}
        <div className="flex items-center gap-4 text-sm text-gray-500 dark:text-gray-400">
          <div className="flex items-center gap-1">
            <Calendar size={14} />
            <span>{post.date}</span>
          </div>
          <div className="flex items-center gap-1">
            <Clock size={14} />
            <span>{post.readTime} {language === 'zh' ? '分钟' : 'min'}</span>
          </div>
        </div>
      </article>
    </Link>
  );
}

export default BlogCard;
